'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).factory('PromotionRequestType', ['$resource', '$stateParams', 'apiSettings', function ($resource, $stateParams, apiSettings) {
	return $resource(apiSettings.baseUri + 'v1/promotionrequeststypes/:id', { id: '@id' }, {
		'list': {
			method: 'GET',
			isArray: true
		},
		'listByPromotionRequest': {
			url: apiSettings.baseUri + 'v1/promotionrequeststypes/by-promotion-request/:id',
			method: 'GET',
			isArray: true
		}
	});
}]);